import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePatchOwnerParams, TypePatchOwnerResponse } from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 화주사 정보] 화주사 정보 수정
 */
const usePatchOwner = () => {
  const { runAsync } = useAsyncHandler();

  const patchOwner = useAPI<TypePatchOwnerParams, TypePatchOwnerResponse>({
    endpoint: API_ENDPOINT.VENDER.PATCH_OWNER,
    method: 'patch',
  });

  const updateOwner = (
    params: TypePatchOwnerParams,
    { onSuccess, onError }: { onSuccess?: () => void; onError?: (error: TypeErrorResponseData['error']) => void } = {}
  ) => {
    return runAsync(() => patchOwner({ params }), {
      onSuccess,
      onError: (error) => {
        onError?.(error as TypeErrorResponseData['error']);
      },
    });
  };

  return { updateOwner };
};

export default usePatchOwner;
